import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m21.266 15.619-.002-.012-1.405-7.255-.004-.016a5.16 5.16 0 0 0-5.072-4.233h-.002l-7.562.022a5.145 5.145 0 0 0-5.082 4.28l-1.4 7.202-.002.011a3.094 3.094 0 0 0 5.27 2.687l3.5-3.869 2.995-.012 3.495 3.88.037.04a3.093 3.093 0 0 0 5.234-2.726M8.938 9.968H8.25v.687a.688.688 0 1 1-1.375 0V9.97h-.687a.688.688 0 1 1 0-1.375h.687v-.688a.687.687 0 1 1 1.375 0v.688h.688a.687.687 0 1 1 0 1.375m3.437-.688a.69.69 0 0 1 .688-.687h2.75a.688.688 0 1 1 0 1.375h-2.75a.687.687 0 0 1-.688-.688m6.143 8.568a1.72 1.72 0 0 1-1.5-.464l-2.674-2.968.439-.002a5.16 5.16 0 0 0 4.377-2.436l.753 3.884a1.72 1.72 0 0 1-1.395 1.986"
    }, null, -1)
  ])))
}
export default { render: render }